import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { palette, fonts } from 'theme';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from 'mdi-material-ui/Close';

import AlertCircleIcon from 'mdi-material-ui/AlertCircle';
import InformationOutlineIcon from 'mdi-material-ui/InformationOutline';
import CircleSmallIcon from 'mdi-material-ui/CircleSmall';

const icons = {
  error: AlertCircleIcon,
  info: InformationOutlineIcon,
  muted: InformationOutlineIcon,
  default: CircleSmallIcon
};

const colors = {
  error: '#b71C1C',
  info: '#1EADF2',
  muted: palette.grey[500],
  default: palette.grey[700]
};

const Heading = styled.div`
  font-weight: bold;
  margin-bottom: 3px;
`;

const Message = styled.div`
  font-family: ${fonts.bodyFamily};
  font-size: 14px;
  margin-top: 2px;
`;

const Alert = styled.div`
  position: relative;
  padding: ${props => (props.slim ? 0 : '15px')};
  border-style: solid;
  border-radius: 5px;
  border-width: ${props => (props.slim ? 0 : '1px')};
  border-color: ${props => colors[props.type] || colors['default']};
  color: ${props => colors[props.type] || colors['default']};
  margin-bottom: ${props => (props.gutterBottom ? '20px' : '0px')};
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
`;

const AlertMessage = ({
  heading,
  message,
  type,
  slim,
  gutterBottom,
  dismissable,
  persistDismissKey,
  ...props
}) => {
  const storageKey = `alert_message_dismissed_${persistDismissKey}`;

  const [dismissed, setDismissed] = useState(
    persistDismissKey ? localStorage.getItem(storageKey) === 'true' : false
  );

  useEffect(() => {
    if (persistDismissKey) {
      localStorage.setItem(storageKey, dismissed);
    }
  }, [dismissed, persistDismissKey, storageKey]);

  const MessageIcon = icons[type] || icons['default'];

  return message && !dismissed ? (
    <Alert type={type} slim={slim} gutterBottom={gutterBottom} {...props}>
      {dismissable && (
        <CloseButton onClick={() => setDismissed(true)}>
          <CloseIcon />
        </CloseButton>
      )}

      <Grid container spacing={8}>
        <Grid item xs="auto">
          <MessageIcon />
        </Grid>
        <Grid item xs>
          {heading && <Heading>{heading}</Heading>}
          <Message>{message}</Message>
        </Grid>
      </Grid>
    </Alert>
  ) : null;
};

export default AlertMessage;
